import { combineReducers } from "redux"
import { tagsInputReducer } from "./availableTagsReducer"
import { courses } from "./courses"
import { subcourses } from "./subcourseReducer"
import { lessonReducers } from "./lessonReducers"
import { sectionsReducer } from "./sectionsReducer"
import { decksReducer } from "./decksReducer"
import { passages } from "./passageReducer"
import { rules } from "./rulesReducer"
import { itemReducers } from "./itemReducers"
import { cards } from "./cardReducer"
import { actMasteryResourcesReducer } from "./actMasteryResourcesReducer"
import { headerReducer } from "./headerReducer"
import { dataDashboard } from "./dataDashboard"
export const authorCourses = combineReducers({
  courses,
  subcourses,
  lessons: lessonReducers,
  sectionsReducer,
  decksReducer,
  passages,
  rules,
  items: itemReducers,
  cards,
  dataDashboard,
  tagsInputReducer
})
export const header = headerReducer
export const actMasteryResources = actMasteryResourcesReducer
